import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContentTypes } from '../activities/activities.enum';

@Component({
  selector: 'app-dev-popup',
  templateUrl: './dev-popup.component.html',
  styleUrls: ['./dev-popup.component.scss'],
})
export class DevPopupComponent {
  @Input({ required: true }) public titleToDisplay: string;
  @Input({ required: true }) public popupVisible: boolean;
  @Input({ required: true }) public protectedPublicURL: string;
  @Input({ required: true }) public popupPublicURL: string;
  @Input({ required: true }) public contentType: ContentTypes;

  @Output() public hiding: EventEmitter<void> = new EventEmitter<void>();

  public readonly content: typeof ContentTypes = ContentTypes;

  public hidePopup(): void {
    this.hiding.emit();
  }
}
